export default "__VITE_ASSET__BerFHn5Q__"